import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "../../common/DashboardLayout";
import PasswordResetModal from "../../admin/PasswordResetModal";
import AuthContext from "../../../context/AuthContext";
import { Lock } from "react-feather";

/**
 * Change Password Page
 * Allows users to change their own password using the password reset tool
 */
const ChangePassword = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(true);

  const handleModalClose = () => {
    setIsModalOpen(false);
    // Navigate back to dashboard after closing
    navigate("/main-dashboard");
  };

  // Get user email from context or localStorage
  const userEmail = user?.email || JSON.parse(localStorage.getItem("user") || "{}")?.email || "";

  return (
    <DashboardLayout>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <div className="d-flex align-items-center mb-4">
                  <Lock size={24} className="me-2" />
                  <h4 className="mb-0">Change Password</h4>
                </div>
                <p className="text-muted">
                  Use the form below to change your password. Your email address will be pre-filled.
                </p>
                
                {/* Password Reset Modal - Pre-fill email if available */}
                {isModalOpen && (
                  <PasswordResetModal
                    open={isModalOpen}
                    onClose={handleModalClose}
                    prefillEmail={userEmail}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default ChangePassword;

